import {
  Component,
  OnDestroy,
  OnInit,
  Input,
  Inject,
  PLATFORM_ID,
  ChangeDetectorRef,
  EventEmitter,
  Output
} from '@angular/core';
import { ViewportService } from '@shared/common/services/viewport/viewport.service';
import { ResizeService } from '../../../core/services/resize/resize.service';
import { Subject } from 'rxjs';
import { bestPrice } from '../../../constants/best-price.constants';
import { languages } from '../../../constants/language.constants';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-best-price',
  templateUrl: './best-price.component.html',
  styleUrls: ['./best-price.component.scss'],
  standalone: false
})
export class BestPriceComponent implements OnInit, OnDestroy {
  bestPrice = bestPrice;
  isOpened: boolean;
  isVisible: boolean;
  private readonly _destruction$: Subject<void> = new Subject<void>();

  @Input() currentLang: languages;
  @Input() amount: number;
  @Input() currency: string;
  @Input() bookingLengthInDays: number;
  @Input() suiteFilterLimitInDays: number;
  @Input() checkin: string;
  @Input() checkout: string;
  @Input() adults: number;
  @Input() children: number;
  @Output() trackBestPriceSidePanel: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private readonly viewportService: ViewportService,
    private readonly resizeService: ResizeService,
    @Inject(PLATFORM_ID) public platformId: Object,
    private readonly cdr: ChangeDetectorRef
  ) {}

  get isMobile() {
    return this.viewportService.isMobileDevice();
  }

  ngOnInit(): void {
    this.detectSmallDevice();

    if (isPlatformBrowser(this.platformId)) {
      this.isVisible = true;
    }
  }
  ngOnDestroy() {
    this._destruction$.next();
    this._destruction$.complete();
  }

  detectSmallDevice() {
    this.cdr.detectChanges(); // fix Expression has changed after it was checked error
  }

  openBanner() {
    this.isOpened = !this.isOpened;

    if (this.isOpened) {
      this.trackBestPriceSidePanel.emit(this.isOpened);
    }
  }
  closeBanner() {
    this.isOpened = false;
  }
}
